import React, { useEffect, useState } from "react";
import { getSDK as getUnlinkSDK } from '../sdk/UnlinkInstance';
import { loadLocalKeys } from "../db/KeyStorageManager";
import { usePasswordAndUserId } from "../context/AuthContext";
import { upsertConversationMeta, conversationExists } from "../db/ConversationMetadata";

export default function NewChatView({ onNewContact, onNewGroup, contacts, navigate }) {
  const unlinkSdk = getUnlinkSDK();
  const { password, userId, salt } = usePasswordAndUserId();
  const [localViewPublicKey, setLocalViewPublicKey] = useState(null);

  useEffect(() => {
    async function fetchKeys() {
      const { viewPublicKey: localViewPublicKey } = await loadLocalKeys({ password, userId, salt });
      setLocalViewPublicKey(localViewPublicKey);
    }

    fetchKeys();
  }, [password, userId, salt]);

  async function onSelectContact(contact) {
    if (!localViewPublicKey) return;

    const conversationId = await unlinkSdk.generateDeterministicConversationId({
      viewKeyA: localViewPublicKey,
      viewKeyB: contact.identityViewPublicKey,
    });

    // create new conversation if not existing
    if (!(await conversationExists({ conversationId }))) {

      await upsertConversationMeta({
        conversationId,
        participants: [localViewPublicKey, contact.identityViewPublicKey],
        userId,
        password,
      });
    }

    navigate({
      name: 'chat',
      props: {
        conversationId,
      },
    });
  }

  // sort ABC
  const sortedContacts = [...contacts].sort((a, b) =>
    a.name.toLowerCase().localeCompare(b.name.toLowerCase())
  );

  // If keys haven't loaded yet, show nothing or a loading state
  if (!localViewPublicKey) {
    return <div style={{ color: "#fff", padding: "2rem" }}>Loading...</div>;
  }

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        backgroundColor: "#000",
        color: "#fff",
        boxSizing: "border-box",
      }}
    >
      {/* Fixed Header */}
      <div
        style={{
          position: "sticky",
          top: 0,
          backgroundColor: "#000",
          padding: "1rem",
          borderBottom: "1px solid #222",
          zIndex: 10,
        }}
      >
        <h2 style={{ margin: 0 }}>New Chat</h2>
      </div>

      {/* Scrollable Content */}
      <div style={{ padding: "1rem", flex: 1, overflowY: "auto" }}>
        <div style={{ display: "flex", flexDirection: "column", gap: "1rem", marginBottom: "2rem" }}>
          <button
            onClick={onNewContact}
            style={{
              width: "100%",
              padding: "0.75rem",
              fontSize: "1rem",
              borderRadius: "6px",
              border: "none",
              backgroundColor: "#4e8cff",
              color: "white",
              cursor: "pointer",
            }}
          >
            New Contact
          </button>

          <button
            onClick={onNewGroup}
            style={{
              width: "100%",
              padding: "0.75rem",
              fontSize: "1rem",
              borderRadius: "6px",
              border: "1px solid #4e8cff",
              backgroundColor: "transparent",
              color: "#4e8cff",
              cursor: "pointer",
            }}
          >
            New Group
          </button>
        </div>

        <h3 style={{ marginBottom: "1rem" }}>Contacts in Unlink</h3>
        {sortedContacts.length === 0 ? (
          <p style={{ color: "#888" }}>No contacts yet. Add one above to start chatting.</p>
        ) : (
          <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
            {sortedContacts.map((contact) => (
              <li
                key={contact.id}
                onClick={() => onSelectContact(contact)}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "1rem",
                  padding: "0.75rem 1rem",
                  borderBottom: "1px solid #333",
                  cursor: "pointer",
                  borderRadius: "6px",
                  marginBottom: "0.5rem",
                  backgroundColor: "#111",
                }}
              >
                <img
                  src="/images/avatar.png"
                  alt="avatar"
                  width="48"
                  height="48"
                  style={{
                    borderRadius: "24px",
                    objectFit: "cover",
                    flexShrink: 0,
                  }}
                />
                <div>
                  <div style={{ fontWeight: "bold", color: "#fff" }}>{contact.name}</div>
                  <div style={{ fontSize: "0.85rem", color: "#aaa" }}>{contact.id}</div>
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}